import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerdatabaseService } from '../../services/customerdatabase.service';

interface ContactDetail {
  id: string;
  vorname: string;
  nachname: string;
  email: string;
  telefonnummer: string;
  mobilnummer: string;
  jobTitle: string;
  city: string;
  company: string;
}

@Component({
  selector: 'app-contact-panel',
  templateUrl: './contact-panel.component.html',
  styleUrls: ['./contact-panel.component.scss']
})
export class ContactPanelComponent implements OnChanges {
  @Input() contactId: string = '';
  @Input() visible: boolean = false;
  @Output() closed = new EventEmitter<void>();

  contact: ContactDetail | null = null;
  loading: boolean = false;

  constructor(
    private customerDB: CustomerdatabaseService,
    private router: Router
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.contactId && this.contactId && this.visible) {
      this.loadContact(this.contactId);
    }
  }

  async loadContact(id: string) {
    this.loading = true;
    this.contact = null;
    try {
      const snap = await this.customerDB.getApplicants().doc(id).get();
      if (snap.exists) {
        const d = snap.data();
        this.contact = {
          id: snap.id,
          vorname: d.vorname || d.firstName || '',
          nachname: d.nachname || d.lastName || '',
          email: d.email || '',
          telefonnummer: d.telefonnummer || d.telefon || '',
          mobilnummer: d.mobilnummer || d.handynummer || d.mobiltelefon || '',
          jobTitle: d.jobTitle || d.jobTitleCleaned || '',
          city: d.wohnort || d.city || (d.Wohnort?.city) || '',
          company: d.unternehmen || d.company || d.employer || ''
        };
      }
    } catch (e) {
      console.error('[ContactPanel] Failed to load contact:', e);
    } finally {
      this.loading = false;
    }
  }

  get fullName(): string {
    if (!this.contact) return '';
    return [this.contact.vorname, this.contact.nachname].filter(Boolean).join(' ') || 'Unknown';
  }

  get initials(): string {
    if (!this.contact) return '?';
    const f = (this.contact.vorname || '?').charAt(0);
    const l = (this.contact.nachname || '').charAt(0);
    return (f + l).toUpperCase();
  }

  close() {
    this.closed.emit();
  }

  onBackdropClick(event: MouseEvent) {
    if ((event.target as HTMLElement).classList.contains('panel-backdrop')) {
      this.close();
    }
  }

  viewFullProfile() {
    if (this.contact) {
      this.router.navigate(['/applicant-information', this.contact.id]);
      this.close();
    }
  }
}
